/*
 | Store Alpine para el ciclo de facturación de las tarjetas de plan.
 | cycle: m (mensual) | a (anual) | b (bienal)
 */
export default {
    cycle: "a",
    flipping: false,
    set(cycle) {
        if (cycle === this.cycle) return;
        this.flipping = true;
        setTimeout(() => { this.cycle = cycle; this.flipping = false; }, 180);
    },
};
